// Tipagem estrutural: aceita DocumentDetail/DocumentSummary sem acoplar ao tipo.
type PdfCandidate = {
  mimeType: string
  originalFilename: string
}

/**
 * O fallback por extensão existe porque uploads antigos podem ter sido gravados
 * como application/octet-stream, sem sniffing de tipo.
 */
export function isPdf(doc: PdfCandidate): boolean {
  return (
    doc.mimeType === 'application/pdf' ||
    doc.originalFilename.toLowerCase().endsWith('.pdf')
  )
}
